import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page" style={{ maxWidth: 900, margin: '20px auto', padding: '16px' }}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective date:</strong> March 19, 2026</p>
      <p>
        This policy applies to DashBasket apps and web services, including DashBasket, Dash Resto,
        and Dash Driver.
      </p>

      <h2>Information we collect</h2>
      <ul>
        <li>Account details such as name, email, and phone number.</li>
        <li>Order and profile data, including delivery addresses.</li>
        <li>Location, camera/photos, and notification token data when features require them.</li>
        <li>Device/app diagnostics to improve reliability and performance.</li>
      </ul>

      <h2>How we use information</h2>
      <ul>
        <li>Provide ordering, restaurant management, and delivery services.</li>
        <li>Authenticate users and secure accounts.</li>
        <li>Send order/delivery notifications and support messages.</li>
        <li>Prevent fraud and comply with legal obligations.</li>
      </ul>

      <h2>Sharing</h2>
      <p>
        We share data only as needed to fulfill orders (customer, restaurant, driver), run our platform,
        or satisfy legal requirements.
      </p>

      <h2>Contact</h2>
      <p>Email: sotairekwizera@gmail.com</p>
    </div>
  );
};

export default PrivacyPolicy;
